var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-image',_vm._g({},_vm.$listeners),[_c('div',{ref:"content",style:(_vm.style)}),(_vm.mode === 'widthFix' || _vm.mode === 'heightFix')?_c('v-uni-resize-sensor',{ref:"sensor",on:{"resize":function($event){return _vm._fixSize()}}}):_vm._e()],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }